var phoneFormatter = (field) => {
  var ret = ''
  var val = field.replace(/\D/g, '').substring(0, 11)
  for (var i = 0, len = val.length; i < len; i++) {
    if (i === 0) {
      ret += '(' + val[i]
    } else if (i === 1) {
      ret += val[i]
    } else if (i === 2) {
      ret += ') ' + val[i]
    } else if (i >= 3 && i <= 5) {
      ret += val[i]
    } else if (i === 6) {
      ret += '-' + val[i]
    } else if (i >= 7 && i <= 9) {
      ret += val[i]
    } else if (i === 10) {
      ret = val.replace(/\D/g, '').replace(/(\d{2})(\d{1})?(\d{4})(\d{4})/g, '($1) $2 $3-$4')
    } else {
      ret += ''
    }
  }
  return ret
}

export const cpf = (cpf) => cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
export const cnpj = (cnpj) => cnpj.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
export const cep = (cep) => cep.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})/g, '$1.$2-$3')
export const ddd = (ddd) => ddd.replace(/\D/g, '').replace(/(\d{2})/g, '($1)')
export const phone = (phone) => phone.replace(/\D/g, '').replace(/(\d{1})?(\d{4})(\d{4})/g, '$1 $2-$3')
export const fullPhone = (phone) => phone.replace(/\D/g, '').replace(/(\d{2})(\d{1})?(\d{4})(\d{4})/g, '($1) $2 $3-$4')
export const t = (context, key, args) => context.rootState._vm.$t(key, args)
export const formatPhone = (field) => phoneFormatter(field)
export const username = () => window.location.hostname.match(/^[A-Za-z0-9-_]*/)[0]



// WEBPACK FOOTER //
// ./src/utils/form.js